export enum Direction {
    North = 'N',
    NorthNorthEast = 'NNE',
    NorthEast = 'NE',
    EastNorthEast = 'ENE',
    East = 'E',
    EastSouthEast = 'ESE',
    SouthEast = 'SE',
    SouthSouthEast = 'SSE',
    South = 'S',
    SouthSouthWest = 'SSW',
    SouthWest = 'SW',
    WestSouthWest = 'WSW',
    West = 'W',
    WestNorthWest = 'WNW',
    NorthWest = 'NW',
    NorthNorthWest = 'NNW',
}
